<div class="modal" role="dialog">
    <div class="modal-dialog modal-extra-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="nav navbar-left navbar-form">
                    <label class="bold input-lg">Projects</label>
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onSelect(null)">Cancel</button>
                </div>
            </div>
            <div class="modal-body">
                <div>
                    <page-status [pageState]="_pageState"></page-status>
                </div>
                <div class="" *ngIf="_entities && _entities.length">
                    <div>Now select a row from below or click 'Cancel'</div>
                </div>
                <default-table>
                    <thead>
                        <tr>
                            <td>Title</td>
                            <td>Content</td>
                            <td>Enabled</td>
                            <td class="text-center">Announcement Date</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let e of _entities" (click)="onSelect(e)">
                            <td>{{e.title}}</td>
                            <td>{{e.content}}</td>
                            <td><input type="checkbox" disabled [checked]="e.enabled"></td>
                            <td class="text-center">{{_stateMap.utilFns.formatDate(e.announcementDate, 'LLL')}}</td>
                        </tr>
                    </tbody>
                </default-table>
            </div>
            <div class="modal-footer">
                <button (click)="onSelect(null)" type="button" class="btn btn-primary">Cancel</button>
            </div>
        </div>
    </div>
</div>
